export default {
  name: 'ui-counter',
  props: {
    value: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: Infinity,
    },
  },
  computed: {
    decrementDisabled() {
      return this.value <= this.min
    },
    incrementDisabled() {
      return this.value >= this.max
    },
  },
  methods: {
    increment() {
      if (this.incrementDisabled) return
      this.$emit('input', this.value + 1)
      this.$emit('change', this.value + 1)
    },
    decrement() {
      if (this.decrementDisabled) return
      this.$emit('input', this.value - 1)
      this.$emit('change', this.value - 1)
    },
    onInput(raw) {
      const parsed = parseInt(raw, 10)
      if (Number.isNaN(parsed)) return
      const clamped = Math.min(Math.max(parsed, this.min), this.max)
      this.$emit('input', clamped)
      this.$emit('change', clamped)
    },
  },
}
